export default __webpack_public_path__ + "static/media/fullscreen.2628a2a6.png";